import { search } from "../../../../BaseRepositoryComponents";

const path = `${process.env.REACT_APP_URL_API_ERP}/erp/vendas/origem/v1`;
const token = process.env.REACT_APP_TOKEN_API_ERP;

const headers = new Headers();
headers.append("Authorization", token);
headers.append("content-type", "application/json");

export async function findOrigem(empresa_cnpj) {
  return search(`${path}?empresa_cnpj=${empresa_cnpj}`, "GET", headers);
}

export async function findIntermediadorByCnpj(empresa_cnpj, cnpjIntermediador) {
  return search(
    `${path}?empresa_cnpj=${empresa_cnpj}&where[cnpj]=${cnpjIntermediador}`
  );
}
